import { useSaleorAuthContext } from '@saleor/auth-sdk/react';
import { useCallback } from 'react';

import { saleorAuthClient } from '@/graphql/client';
import { BRAND } from '@/lib/const';
import { paths } from '@/lib/paths';

export const useCustomSignOut = () => {
  const { signOut: originalSignOut } = useSaleorAuthContext();

  const signOut = useCallback(async () => {
    try {
      await saleorAuthClient.fetchWithAuth(
        paths.api.abandonCart,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ brand: BRAND.toUpperCase() }),
          credentials: 'include',
        },
        { allowPassingTokenToThirdPartyDomains: true },
      );
    } catch (error) {
      console.error('Error during sign-out cleanup:', error);
    }

    await originalSignOut();
  }, [originalSignOut]);

  return { signOut };
};
